if(!customElements.get('risify-collection-header')){
  class RisifyCollectionHeader extends HTMLElement {
    constructor() {
      super();
      this.container = this.querySelector('.risify-navigator__swiper');
      this.nextButton = this.querySelector('.risify-description__nav.next');
      this.prevButton = this.querySelector('.risify-description__nav.prev');
      this.swiper = new Swiper(this.container, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        freeMode: false,
        watchOverflow: true,
        navigation:{
          nextEl: this.nextButton,
          prevEl: this.prevButton,
        },
        breakpoints: {
          768: {
            spaceBetween: 24,
          }
        }
      });
      // Description Start
      this.productGrid = this.parentElement.nextElementSibling;
      this.description = this.querySelector('.risify-description-wrapper');
      this.inputs = this.querySelectorAll('.risify-description__toggle input');
      this.selectList = this.querySelector('.risify-description__toggle-list');
      this.icon = this.querySelector('.risify-description__toggle-text svg');
      this.toggle = this.querySelector('.risify-description__toggle-text');
      this.activeText = this.querySelector('.risify-description__toggle-text .active-js');

      this.inputs.forEach((input)=>{
        input.addEventListener('change', (e)=>{
          if(e.target.id == 'description'){
            this.description.classList.add('active');
            this.productGrid.classList.add('hidden');
            this.activeText.textContent = 'Description';
          }
          if(e.target.id == 'grid'){
            this.description.classList.remove('active');
            this.productGrid.classList.remove('hidden');
            this.activeText.textContent = 'Products';
          }
          this.selectList.classList.remove('active');
          this.icon.classList.remove('active');
        })
      })
      this.toggle.addEventListener('click', (e)=>{
        this.icon.classList.toggle('active');
        this.selectList.classList.toggle('active');
      })
    }
  }
  customElements.define('risify-collection-header', RisifyCollectionHeader);
}